import React from "react";
import { connect } from "react-redux";

@connect(store => {
    return {
        files: store.files
    };
})

class Comment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searched: []
        }
    }

    render() {
        const { dispatch, files } = this.props;
        
        const handleChange = (e) => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {comment: {value: e.target.value}} });
        }
        return (
            <div class="optionRow">
                <span>Comment</span>
                <div class="optionChoices searchComment">
                    <input type="text" placeholder="Search" value={files.filters.options.comment.value || ""} onChange={handleChange} />
                </div>
            </div>
        );
    }
}

export default Comment;